/* eslint-disable no-use-before-define,no-empty-pattern */
import React from 'react'
import { fmt, hideModal, showBondOrder, } from '../twd'
import { useBondDetail } from './use-bond-detail'

export let Sell = ({dataName='bond-detail-sell' } = {}) => {
    let {issue, hold, bid, } = useBondDetail()

    if (hold.length===0) return null

    return bid && bid.id && issue.allowTrading
        ? order({
            label: 'Sell',
            style: { minWidth:'69px', minHeight:'25px', marginLeft:'20px'},
            action: 'S',
            acctNo: hold[0].acctNo,
            cusip: issue.cusip,
            dataName,
            className: 'btn btn-primary'
        })
        : null
}

export let Buy = ({dataName='bond-detail-buy' } = {}) => {
    let {issue, ask} = useBondDetail()

    return ask && ask.id && issue.allowTrading
        ? order({
            label: 'Buy',
            style: { minWidth:'69px', minHeight:'25px', marginLeft:'20px'},
            action: 'B',
            cusip: issue.cusip,
            dataName,
            className: 'btn btn-primary'
        })
        : fmt.orderPhone({ style: {marginLeft:'20px' }})
}

export let Bid = ({dataName='bond-detail-bid' } = {}) => {
    let {issue, bid, hold, } = useBondDetail()

    let h = hold[0]
    var action = 'S'
    if (h) {
        let bidQty = parseFloat(bid.quantity)
        let holdQty = h.qty
        action = bidQty > holdQty ? 'S' : 'W'
    }

    return  issue.allowTrading && h
        ? order({
            label: fmt.price3N(bid.dispPrice),
            action,
            acctNo: hold[0].acctNo,
            cusip: issue.cusip,
            dataName,
        })
        : fmt.price3N(bid.dispPrice)
}


export let Ask = ({dataName='bond-detail-ask'} = {}) => {
    let { issue, ask, } = useBondDetail()

    return ask && ask.id && issue.allowTrading
        ? order({
            action: 'B',
            label: fmt.price3N(ask.dispPrice),
            cusip: issue.cusip,
            dataName,
        })
        : fmt.price3N(ask.dispPrice)
}

export let BidWanted = ({dataName='bond-detail-ask'} = {}) => {
    let { issue, hold, } = useBondDetail()

    return issue.allowTrading && hold.length>0
        ? order({
                action: 'W',
                label: 'Bid wanted',
                acctNo: hold[0].acctNo,
                cusip: issue.cusip,
                dataName,
            })
        : null
}

export let OfferWanted = ({dataName='bond-detail-ask'} = {}) => {
    let { issue, } = useBondDetail()

    return issue.allowTrading
        ? order({
            action: 'F',
            label: 'Offer wanted',
            cusip: issue.cusip,
            dataName,
        })
        : null
}

let order = ({label, cusip, acctNo='', qty='', action='B', sourceAction='', dataName='', style={}, className='link-button' }) => <a href='#'
    data-name={dataName}
    type="button"
    className={className}
    style={style}
    onClick={() => {
        hideModal()
        showBondOrder({
            action,
            cusip,
            acctNo,
            qty,
            sourceAction,
            ts: Date.now(),
            from: '#bond-detail.' + cusip
        })
    }}
    >{label}</a>


// WEBPACK FOOTER //
// ./src/bond-detail/order.js